<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    <strong>CERTIDÕES</strong>
                    <!-- <strong>{{ fornecedor.cgcCfo }} - {{ fornecedor.nome }}</strong>
                    <b-badge variant="warning" class="ml-2">{{operacao}}</b-badge>-->
                </span>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col sm="12" md="6">
                        <cnd :fornecedor="fornecedor"></cnd>
                    </b-col>
                    <b-col sm="12" md="6">
                        <fgts :fornecedor="fornecedor"></fgts>
                    </b-col>
                </b-row>
            </b-card-body>
            <!-- <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                        <b-button
                            variant="primary"
                            @click.stop="atualizarCertidoes()"
                            v-if="$temAcessoView('CERT-03')"
                            class="ml-1"
                        >
                            <span>
                                <i class="fa fa-refresh mr-2"></i> Atualizar
                                Certidões
                            </span>
                        </b-button>
            </b-card-footer>-->
        </b-card>
    </div>
</template>

<script>
import CertidoesServicos from './CertidoesServicos'
import Cnd from './Cnd'
import Fgts from './Fgts'

export default {
	props: {
		fornecedorId: {
			type: String,
			default: () => null
		},

		dataServico: {
			type: Object,
			default: () => {}
		}
	},

	components: { Cnd, Fgts },

	data() {
		return {
			fornecedor: {}
		}
	},

	methods: {
		voltar() {
			this.$router.push({ name: 'Certidoes' })
		},

		obterCertidoes() {
			this.$store.dispatch('addRequest')
			let promisse
			if (this.fornecedorId) {
				promisse = this.dataServico.obterCertidoes(this.fornecedorId)
			} else {
				promisse = CertidoesServicos.obterDados()
			}
			promisse.then(response => {
				if (response) {
					if (response.success) {
						this.fornecedor = response.data
					} else {
						this.erros = response.errors
					}
				}
				this.$store.dispatch('removeRequest')
			})
		}
	},

	computed: {},

	created() {
		this.obterCertidoes()
	}
}
</script>
